<template>
    <div style="position: relative">   
        <div>
            <!-- <div 
                class="font-weight-medium">
                {{$store.state.events.month.getFullYear()}} 年 {{$store.state.events.month.getMonth() + 1}} 月
            </div> 
            <div>{{$store.state.events.start}}</div>
            <div>{{$store.state.events.end}}</div>
            <div>{{(new Date((new Date()).getFullYear() + '-' + ((new Date()).getMonth()+1).toString().padStart(2, '0') + '-01'))}}</div>
            <div>{{(new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1))}}</div>
            <div>{{new Date()}}</div>
            <div>{{new Date('2021-03-01')}}</div>
            <div>{{(new Date(2021,2,1))}}</div>
            <div>{{new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1)}}</div>
            <div>a{{this.debugTime}}</div> -->

            <div>Text</div>
            <v-btn @click="callAPI">Call API</v-btn>
        </div>
        
    </div>
</template>



<script>
    import { mapGetters } from "vuex";
    import {formatToTimeZone} from 'date-fns-timezone';
    import axios from 'axios';
    const FORMAT = 'YYYY-MM-DD HH:mm:ss';
    const TIME_ZONE_TOKYO = 'Asia/Tokyo';

    export default {


        // data() {
        //     return {
        //         hidden : true,
        //         url : "/host/createGroupSeminar",
        //         checkboxShowPastEvent: false, 
                
        //     };
        // },


        methods:{



            getDayOfWeek(day){
                //日本時間での曜日
                const tday = new Date(formatToTimeZone((new Date(day)), FORMAT, {timeZone: TIME_ZONE_TOKYO}))
                return [ "日", "月", "火", "水", "木", "金", "土" ][tday.getDay()];
            },
            testadd(){
                console.log('testadd')
                console.log(this.users_info)
                this.tmpfunc(this.users_info)
            },
            
            doReload() {
                console.log('r')
            // reloadメソッドによりページをリロード
            // window.location.reload();
            window.location.href = 'http://localhost:8080/debug'
            },

            callAPI(){
                //セールス担当の場合
                if(this.role.sales){
                    // const url = 'https://us-central1-seminar-app-e5eb3.cloudfunctions.net/helloWorld'
                    const url = 'http://localhost:5001/seminar-app-e5eb3/us-central1/helloWorld'



                    axios.get(url)
                    .then(function (response) {
                        // handle success
                        console.log(response);

                        // rsp.send(response.data)
                        // func();
                        // return response.status;
                    })
                    .catch(function (error) {
                        // handle error
                    console.log(error);
                    })
                    .finally(function () {
                        // always executed
                    });
                }

            }
        },

        computed:{
            ...mapGetters(['role', 'login_user', 'uid', 'users_info']),

            debugTime(){
                return new Date(formatToTimeZone((new Date()), FORMAT, {timeZone: TIME_ZONE_TOKYO}).replace(/-/g,"/"))
                // return formatToTimeZone((new Date()), FORMAT, {timeZone: TIME_ZONE_TOKYO}).replace(/-/g,"/")
                
                // var date = new Date(dt.replace(/-/g,"/"));
            },
            getEventToShow(){
                if(!this.checkboxShowPastEvent){
                    return this.$store.state.events.events.filter(function(event){
                        // 日本時間の現在時刻
                        const d = new Date(formatToTimeZone((new Date()), FORMAT, {timeZone: TIME_ZONE_TOKYO}))
                        var formatted = `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`.replace(/\n|\r/g, '');
                        if(event.date >= formatted) return true;
                    });
                }else{
                    return this.$store.state.events.events;
                }
            },
            
        }
    };
  
</script>

<style scoped lang="scss">
a{
    text-decoration :none;
}
</style>